import { render, staticRenderFns } from "./PortineriaBarView.vue?vue&type=template&id=ad0cb352&"
import script from "./PortineriaBarView.vue?vue&type=script&lang=ts&"
export * from "./PortineriaBarView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports